import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { SliderInput as SliderInput$1 } from '@reach/slider';
export { SliderOrientation } from '@reach/slider';
import { Box } from '../Box/index.js';
import 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { useSliderContext } from './SliderContext.js';

var SliderInput = function (props) {
    var _a = useSliderContext(), min = _a.min, max = _a.max, displayValue = _a.displayValue;
    var children = props.children; props.themeKey; var forwardProps = __rest(props, ["children", "themeKey"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var css = handleStyleProps(props, { themeKey: "sliderInput" }).css;
    return (jsx(Box, __assign({ css: css, "data-display-value": displayValue }, { children: jsx(SliderInput$1, __assign({ min: min, max: max }, forwardProps, { children: children })) })));
};
SliderInput.displayName = "SliderInput";

export { SliderInput };
//# sourceMappingURL=SliderInput.js.map
